export const useIsIntegrated = (): boolean => window.self !== window.top;
